import React from 'react';
import styled from 'styled-components';
import { Avatar, NewTabLink } from '../../../../common';

const CompanyTitle = ({ name, companyImage, companyUrl, ...other }) => (
  <CompanyTitleWrapper {...other} href={companyUrl}>
    <CompanyAvatar src={companyImage} size={42} />
    <Title>{name}</Title>
  </CompanyTitleWrapper>
);

export default CompanyTitle;

const Title = styled.div`
  color: #787878;
`;

const CompanyTitleWrapper = styled(NewTabLink)`
  display: flex;
  align-items: center;
`;

const CompanyAvatar = styled(Avatar)`
  margin-right: 8px;
  border: 1px solid lightgray;
`;
